import Modal from '../../../../../components/modal/Modal';

import { formatKm } from '../../../../../utils/format';

import imageThunderBlue from '../../../../../assets/thunder_blue.svg';
import imageThunderGreen from '../../../../../assets/thunder_green.svg';
import imageThunderWhite from '../../../../../assets/thunder_white.svg';

import clock from '../../../../../assets/clock.svg';
import checkCircleOutiline from '../../../../../assets/check_circle_outline.svg';
import helpIcon from '../../../../../assets/helpIcon.svg';
import place from '../../../../../assets/place.svg';
import pin from '../../../../../assets/pin_drop.svg';

import Button from '../../../../../components/button/Button';
import { useToastStore } from '../../../../../hooks/useToastStore';
import ToastMapsOptions from '../../../../../components/toastMapsOptions/ToastMapsOptions';
import ToastHelp from '../../../../../components/toastHelp/ToastHelp';

interface ModalConnectorInfoProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  brandColor: string;
  info: any;
}

export const ModalConnectorInfoComponent = ({
  isModalOpen,
  setIsModalOpen,
  brandColor,
  info
}: ModalConnectorInfoProps) => {
  const { csLocation = {} } = info;
  const { coordinates = [0, 0] } = csLocation;

  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${coordinates[1]},${coordinates[0]}`;
  const appleURl = `http://maps.apple.com/?q=${coordinates[1]},${coordinates[0]}`;
  const wazeUrl = `https://waze.com/ul?ll=${coordinates[1]},${coordinates[0]}&navigate=yes`;

  const {
    showDirectionsToast,
    showHelpToast,
    setShowHelpToast,
    setShowDirectionsToast
  } = useToastStore();

  let total_status_icons = 6;

  const icon_available_count =
    info?.chargerSiteStatus?.available > total_status_icons
      ? total_status_icons
      : info?.chargerSiteStatus?.available;
  total_status_icons =
    total_status_icons - icon_available_count < 0
      ? 0
      : total_status_icons - icon_available_count;

  const icon_inUse_count =
    info?.chargerSiteStatus?.inUse > total_status_icons
      ? total_status_icons
      : info?.chargerSiteStatus?.inUse;
  total_status_icons =
    total_status_icons - icon_inUse_count < 0
      ? 0
      : total_status_icons - icon_inUse_count;

  const icon_offLine_count =
    info?.chargerSiteStatus?.offLine > total_status_icons
      ? total_status_icons
      : info?.chargerSiteStatus?.offLine;

  return (
    <>
      <Modal
        allowButtonClosed={false}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          //   setIsCsDetailActive(false);
        }}
        // textEnterButton='Ver mais'
        // handleEnterButton={() => navigateToCharger(info)}
        isLoadingEnterButton={false}
        styleEnterButton={{ backgroundColor: brandColor }}
        disableEnterButton={false}
        modalBackdrop={false}
        header={false}
      >
        {info?.csName && (
          <div className="charger-station-details" style={{ padding: 0 }}>
            <h1 className="charger-station-name">{info.csName}</h1>

            {/* Endereço */}
            <div className="charger-station-detail-lines">
              <img
                src={place}
                className={'charger-icon charger-icon-blue'}
                alt="Local"
              />
              <span className="charger-station-detail-lines_text charger-station-address">
                <b>{formatKm(info.distanceMeters / 1000)} km </b> -{' '}
                {info.csFormattedAddress}
              </span>
            </div>

            {/* Estacionamento */}
            <div className="charger-station-detail-lines">
              <img
                src={checkCircleOutiline}
                className={'charger-icon'}
                alt="Estacionamento"
              />
              <span className="charger-station-detail-lines_text charger-station-parking-info">
                {info.csFreeParking
                  ? 'Estacionamento: gratuito'
                  : 'Estacionamento: pago'}
              </span>
            </div>

            {/* Horário */}
            <div className="charger-station-detail-lines">
              <img
                src={clock}
                className={'charger-icon charger-icon-blue'}
                alt="Horário"
              />
              <span className="charger-station-detail-lines_text charger-station-operation-hours">
                {`${info?.csPrivate ? 'Privado / ' : 'Público / '} ${
                  info.isOpen ? 'Aberto' : 'Fechado'
                }`}
              </span>
            </div>

            {/* Status dos carregadores */}
            <div
              className="charger-card-chargers"
              style={{ justifyContent: 'flex-start', marginTop: '16px' }}
            >
              <span className="charger-card-chargers_thunder">
                {Array.from({ length: icon_available_count }).map(
                  (_, index) => (
                    <img
                      key={`available-${index}`}
                      src={imageThunderGreen}
                      className={'charger-icon charger-icon-green'}
                      alt="Disponível"
                      width={10}
                      style={{ marginRight: '5px' }}
                    />
                  )
                )}
                {Array.from({ length: icon_inUse_count }).map((_, index) => (
                  <img
                    key={`inUse-${index}`}
                    src={imageThunderBlue}
                    className={'charger-icon charger-icon-blue'}
                    alt="Em uso"
                    width={10}
                    style={{ marginRight: '5px' }}
                  />
                ))}
                {Array.from({ length: icon_offLine_count }).map((_, index) => (
                  <img
                    key={`offLine-${index}`}
                    src={imageThunderWhite}
                    className={'charger-icon charger-icon-white'}
                    alt="Não disponível"
                    width={10}
                    style={{ marginRight: '5px' }}
                  />
                ))}
              </span>
            </div>

            {/* Ações */}
            <div className="actions-container" style={{ marginBottom: '5px' }}>
              <Button
                className="btn-outline-md"
                type="button"
                children="Como Chegar"
                spinnerSecondary={true}
                onClick={() => setShowDirectionsToast(true)}
                image={<img src={pin} alt="Como Chegar" />}
                style={{ fontSize: 15 }}
              />

              <Button
                className="btn-outline-md"
                type="button"
                children="Ajuda"
                spinnerSecondary={true}
                onClick={() => setShowHelpToast(true)}
                image={<img src={helpIcon} alt="Ajuda" />}
                style={{ fontSize: 15 }}
              />
            </div>
          </div>
        )}
      </Modal>
      <ToastMapsOptions
        googleMapsUrl={mapUrl}
        appleMapsUrl={appleURl}
        wazeUrl={wazeUrl}
        isModalOpen={showDirectionsToast}
        allowButtonClosed={true}
        setShowToastMapsOptions={setShowDirectionsToast}
      />
      <ToastHelp
        isModalOpen={showHelpToast}
        allowButtonClosed={true}
        setShowHelpToast={setShowHelpToast}
      />
    </>
  );
};
